import React from 'react';

import { BlockquoteContainer } from '../styles';

import { NodeProps } from './shared';

export function BlockquoteNode({ children }: NodeProps) {
  return (
    <BlockquoteContainer
      backgroundColor="brand"
      borderRadius={{ 0: 'blockquote_0', tablet: 'blockquote_tablet' }}
    >
      {children}
    </BlockquoteContainer>
  );
}
